export default (theme) => ({
  wrap: {
    width: "100%",
    borderRadius: 16,
    background: "#2B2B37",
    color: "white",
    minHeight: "100vh",
  },
  header: {
    padding: "24px 60px",
    fontSize: "16px",
    "@media (max-width: 600px)": {
      padding: "12px 30px",
      fontSize: "11px",
    },
    display: "flex",
    justifyContent: "space-between",
    borderBottom: "1px solid #555555",
    flexWrap: "wrap",
  },
  expirationDate: {
    margin: "auto 0",
    fontFamily: "DINProCond",
    fontSize: 16,
    lineHeight: "24px",
    "& span": {
      letterSpacing: "0.5px",
    },
    "@media (max-width: 600px)": {
      fontSize: "11px",
    },
  },
  insuranceItemId: {
    position: "absolute",
    right: 0,
  },
  breadCrumbsSeperator: {
    lineHeight: "13px",
  },
  breadCrumbsItem: {
    color: "white",
    fontFamily: "DINProCond",
    lineHeight: "13px",
    fontSize: "16px",
    cursor: "pointer",
    "@media (max-width: 600px)": {
      fontSize: "11px",
    },
    "&:hover, &:focus": {
      color: "#F05A28",
    },
    "&:active": {
      color: "#F05A28",
    },
  },

  breadCrumbsLi: {
    color: "#DADADA",
  },
  content: {
    display: "flex",
    justifyContent: "space-between",
    "@media (max-width: 1100px)": {
      flexWrap: "wrap",
    },
  },
  items: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    borderRight: "1px solid #555555",
    position: "relative",
    width: "100%",
    height: "100%",
  },
  loading: {
    pointerEvents: "none",
  },
  badge: {
    backgroundColor: "#F05A28",
    height: "15px",
    minWidth: "15px",
  },
  item: {
    minHeight: 130,
    padding: "48px 60px",
    "@media (max-width: 600px)": {
      padding: "24px 30px",
    },
    borderBottom: "1px solid #333333",
    "&:last-child": {
      border: "none",
    },
  },
  sidebar: {
    minWidth: 400,
    maxWidth: 400,
    padding: "48px 60px",
    "@media (max-width: 600px)": {
      padding: "24px 30px",
    },
  },
  itemTitle: {
    color: "#F9F9F9",
    fontFamily: "DINPro",
    fontSize: 24,
    marginTop: 0,
    "@media (max-width: 600px)": {
      fontSize: 20,
    },
    marginBottom: 24,
    lineHeight: "32px",
  },
  orderTitle: {
    padding: "48px 60px 24px 60px",
    fontFamily: "DINPro",
    fontSize: "24px",
    lineHeight: "32px",
    margin: 0,
    "@media (max-width: 600px)": {
      padding: "24px 30px",
    },
    color: "#F9F9F9",
  },
  paymentTitle: {
    padding: "48px 60px 24px 60px",
    fontFamily: "DINPro",
    fontSize: "24px",
    lineHeight: "32px",
    margin: 0,
    "@media (max-width: 600px)": {
      padding: "24px 30px",
    },
    color: "#F9F9F9",
  },
  paymentFooterTitle: {
    padding: "48px 0 24px 0",
    fontFamily: "DINPro",
    fontSize: "24px",
    lineHeight: "32px",
    margin: 0,
    "@media (max-width: 600px)": {
      padding: "24px 0 8px 0",
    },
    color: "#F9F9F9",
  },
  paymentItem: {
    display: "flex",
    padding: "0 60px 48px 60px",
    justifyContent: "space-between",
    flexWrap: "wrap",
    "@media (max-width: 900px)": {
      flexDirection: "column",
    },
    "@media (max-width: 600px)": {
      padding: "0 30px 24px 30px",
    },
    borderBottom: "1px solid #333333",
  },
  paymentInput: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    margin: "8px 8px 8px 0",
    "& label": {
      marginBottom: 4,
      fontFamily: "Circe",
      fontSize: "12px",
      lineHeight: "20px",
      display: "flex",
      alignItems: "center",
      color: "#B6B6B6",
    },
    "& input": {
      textTransform: "uppercase",
      minWidth: 240,
    },
  },
  fullWidth: {
    width: "100%",
    "& input": {
      width: "100%",
      minWidth: 240,
    },
  },
  flex: {
    display: "flex",
    width: "100%",
    "@media (max-width: 900px)": {
      flexDirection: "column",
    },
  },
  paymentFooter: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    margin: "2px 60px 60px 60px",
    "@media (max-width: 600px)": {
      margin: "2px 30px",
    },
  },
  paymentFooterItem: {
    display: "flex",
    justifyContent: "flex-start",
    margin: "6px 0",
    flexWrap: "wrap",
    cursor: "pointer",
  },
  paymentFooterItemHeader: {
    display: "flex",
    justifyContent: "flex-start",
    borderBottom: "2px solid #B6B6B6",
    paddingBottom: 4,
    marginBottom: 6,
  },
  paymentFooterItemName: {
    fontFamily: "DINProCond",
    fontSize: "16px",
    lineHeight: "24px",
    color: "#DADADA",
    textTransform: "uppercase",
    minWidth: 203,
  },
  paymentFooterItemHeaderName: {
    fontFamily: "Circe",
    fontSize: "12px",
    lineHeight: "20px",
    display: "flex",
    alignItems: "center",
    color: "#B6B6B6",
    minWidth: 203,
  },
  paymentFooterItemHeaderValue: {
    fontFamily: "Circe",
    fontSize: "12px",
    lineHeight: "20px",
    display: "flex",
    alignItems: "center",
    color: "#B6B6B6",
    minWidth: 203,
  },
  paymentFooterItemValue: {
    fontFamily: "DINPro",
    fontSize: "16px",
    lineHeight: "24px",
    color: "#FFF",
    minWidth: 203,
    "& ul": {
      margin: 0,
      padding: 0,
      listStyle: "none",
      "& li": {},
    },
  },
  orderItem: {
    minHeight: 88,
    margin: "2px 60px",
    padding: "40px 32px",
    display: "flex",
    background: "#373743",
    borderRadius: "4px",
    cursor: "pointer",
    justifyContent: "space-between",
    "&:hover": {
      "& $orderItemActions": {
        display: "flex",
      },
    },
    "@media (max-width: 600px)": {
      margin: "2px 30px",
    },
  },
  orderFlexItem: {
    minHeight: 88,
    margin: "2px 60px",
    padding: "40px 32px",
    display: "flex",
    background: "#373743",
    borderRadius: "4px",
    cursor: "pointer",
    flexDirection: "column",
    justifyContent: "space-between",
    "@media (max-width: 600px)": {
      margin: "2px 30px",
    },
  },
  orederInputsWrap: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    "@media (max-width: 680px)": {
      flexWrap: "none",
      flexDirection: "column",
    },
    marginBottom: 24,
  },
  orderItemTitle: {
    fontFamily: "CirceBold",
    fontSize: "16px",
    lineHeight: "24px",
    display: "flex",
    margin: 0,
    alignItems: "center",
    textTransform: "uppercase",
    color: "#FFFFFF",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    "& span": {
      textTransform: "lowercase",
      fontFamily: "CirceMedium",
      fontSize: "16px",
      lineHeight: "24px",
      display: "flex",
      alignItems: "center",
      color: "#B6B6B6",
      margin: "0 8px",
    },
    "@media (max-width: 800px)": {
      display: "block",
      "& span": {
        margin: "0",
      },
    },
  },
  orderItemActions: {
    display: "none",
    justifyContent: "space-between",
  },
  orderItemEditActions: {
    display: "flex",
    justifyContent: "flex-end",
  },
  orderEditItem: {
    display: "flex",
    alignItems: "space-between",
    color: "#FFFFFF",
    margin: "auto 8px",
    "& p": {
      margin: 0,
      fontFamily: "CirceMedium",
      fontSize: "16px",
      lineHeight: "24px",
      display: "flex",
      alignItems: "center",
      "@media (max-width: 800px)": {
        display: "none",
      },
    },
    "& svg": {
      margin: "3px 8px",
      fontSize: "16px",
    },
    "&:hover": {
      color: "#F05A28 !important",
    },
  },
  orderAddPeople: {
    margin: "4px 60px",
    padding: "40px 32px",
    display: "flex",
    background: "#373743",
    borderRadius: "4px",
    flexWrap: "wrap",
    justifyContent: "space-between",
    "@media (max-width: 760px)": {
      flexWrap: "none",
      flexDirection: "column",
    },
    "@media (max-width: 600px)": {
      margin: "16px 30px !important",
    },
  },
  orderAddPeopleItem: {
    display: "flex",
    // width:'50px',
    flexDirection: "column",
    margin: "10px 0",
    "& label": {
      marginBottom: 4,
    },
    "& input": {
      minWidth: 260,
      textTransform: "uppercase",
    },
  },
  // orderAddPeopleItemBirthday: {
  //   display: 'flex',
  //   // width:'50px',
  //   flexDirection: 'column',
  //   margin: '10px 0',
  //   '& label': {
  //     marginBottom: 4,
  //   },
  //   '& input': {
  //     minWidth: 120,
  //     textTransform: 'uppercase'
  //   }
  // },
  addPeopleButton: {
    margin: "24px 60px !important",
    letterSpacing: "0.5px !important",
    textTransform: "none !important",
    fontFamily: "CirceMedium !important",
    fontSize: "18px !important",
    lineHeight: "24px !important",
    "@media (max-width: 600px)": {
      margin: "16px 30px !important",
    },
    backgroundColor: "transparent !important",
    border: "1px solid #F05A28",
  },
  insuredDetailsContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "start",
    flexWrap: "wrap",
    maxWidth: "100%",
    margin: "24px 60px",
    "@media (max-width: 600px)": {
      margin: "16px 30px !important",
    },
  },
  insuredDetails: {
    // margin: '0 24px !important',
    marginRight: "24px",
    letterSpacing: "0.5px !important",
    textTransform: "none !important",
    fontFamily: "CirceMedium !important",
    fontSize: "18px !important",
    lineHeight: "24px !important",
    // width:'120px',
    "@media (max-width: 600px)": {
      margin: "0 12px 12px 0 !important",
    },
    backgroundColor: "transparent !important",
    border: "1px solid #F05A28",
  },
  aboutInsure: {
    display: "flex",
    flexDirection: "column",
    margin: "40px 0",
    "& p": {
      color: "#F05A28",
      cursor: "pointer",
    },
  },
  aboutInsureTitle: {
    fontFamily: "DINPro",
    fontSize: "24px",
    lineHeight: "32px",
    color: "#F9F9F9",
    marginBottom: 25,
  },
  aboutInsureItem: {
    fontFamily: "Circe",
    fontSize: "16px",
    lineHeight: "24px",
    color: "#FFFFFF",
    margin: "8px 0",
    overflow: "hidden",
    display: "inline-block",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    "& img": {
      width: "14px",
      height: "18px",
      marginRight: "8px",
    },
  },
  orangeBadge: {
    background: "#f05a28",
    width: 17,
    height: 17,
    top: -7,
    fontSize: 10,
    padding: 0,
    minWidth: 0,
  },
  noBadge: {
    display: "none",
  },
  nextButton: {
    padding: "9px 64px !important",
    letterSpacing: "0.5px !important",
    textTransform: "none !important",
    fontFamily: "CirceBold !important",
    fontSize: "18px !important",
    lineHeight: "24px !important",
  },
  input: {},
  dates: {
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "wrap",
    "& > div": {
      margin: "20px 0",
    },
  },
  datepickerWrapper: {
    "@media (max-width: 730px)": {
      width: "50%",
    },
  },
  datepickerInput: {
    width: "164px",
  },
  radio: {
    color: "white !important",
    "&:hover": {
      backgroundColor: "transparent",
    },
    "input:hover": {
      backgroundColor: "transparent",
    },
  },
  selectedRadio: {
    color: "#F05A28 !important",
    "input:hover": {
      backgroundColor: "transparent",
    },
  },
  controlLabel: {
    fontFamily: "Circe",
    fontSize: 16,
    lineHeight: "24px",
    margin: 0,
  },
  rootSwitch: {
    width: 42,
    height: 26,
    padding: 0,
    margin: theme.spacing(1),
  },
  switchBase: {
    padding: 3,
    "&$checked": {
      left: "unset",
      transform: "translateX(16px)",
      color: "#F05A28",
      "& + $track": {
        opacity: 1,
        border: "none",
      },
    },
    "&$focusVisible $thumb": {
      color: "white",
      border: "6px solid #fff",
    },
  },
  thumb: {
    width: 20,
    height: 20,
    backgroundColor: "white",
  },
  track: {
    borderRadius: 26 / 2,
    backgroundColor: "#F05A28 !important",
  },
  checked: {},
  itemTitleWrap: {
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "wrap",
    alignItems: "flex-start",
  },
  sportInput: {
    width: "100%",
  },
  arrowDown: {
    margin: "auto 0",
    transition: "all .3s ease-in",
  },
  arrowUp: {
    margin: "auto 0",
    transition: "all .3s ease-in",
    transform: "rotate(180deg)",
  },
  blueButton: {
    background: "rgba(40, 168, 240, 0.1) !important",
    borderRadius: 4,
    minWidth: 40,
    marginLeft: 43,
    margin: "0 0 auto 0",
    padding: "9px 16px !important",
    letterSpacing: "0.5px !important",
    textTransform: "none !important",
    fontFamily: "Circe !important",
    fontSize: "18px !important",
    lineHeight: "19px !important",
  },
  deleteButton: {
    background: "#f05a28 !important",
    borderRadius: 4,
    minWidth: 40,
    margin: "0 0 auto 0",
    padding: "7px 16px !important",
    marginLeft: 43,
    letterSpacing: "0.5px !important",
    textTransform: "none !important",
    fontFamily: "Circe !important",
    fontSize: "18px !important",
    lineHeight: "24px !important",
  },
  sidebarBlueButton: {
    background: "rgba(40, 168, 240, 0.1) !important",
    borderRadius: 4,
    minWidth: 170,
    padding: "8px 16px !important",
    letterSpacing: "0.5px !important",
    textTransform: "none !important",
    fontFamily: "Circe !important",
    fontSize: "18px !important",
    lineHeight: "24px !important",
    display: "flex",
    margin: "40px 0",
    justifyContent: "space-between",
    "&:before": {
      position: "absolute",
      top: -35,
      left: 0,
      fontSize: 45,
      letterSpacing: -4,
      content: "'• • •'",
      display: "inline-block",
    },
  },
  deleteDots: {
    "&:before": {
      position: "absolute",
      top: -35,
      left: 0,
      fontSize: 45,
      letterSpacing: -4,
      content: "''",
      display: "inline-block",
    },
  },
  competitionFlex: {
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "wrap",
  },
  competitionFlexChilds: {
    display: "flex",
    justifyContent: "start",
    flexWrap: "wrap",
    margin: "6px 0",
    "@media (max-width: 480px)": {
      flexDirection: "column",
      "& > div": {
        margin: "6px 0",
      },
      "& > button": {
        margin: 0,
      },
    },
  },
  competitionDeleteChilds: {
    display: "flex",
    justifyContent: "start",
    margin: "6px 0",
  },
  insuranceValue: {
    fontFamily: "CirceBold",
    fontSize: 36,
    marginTop: 0,
    marginBottom: 24,
    fontWeight: "bold",
    textAlign: "center",
    lineHeight: "46px",
    letterSpacing: "-0.8px",
    color: "#FFFFFF",
  },
  packages: {
    display: "flex",
    justifyContent: "space-justify",
    flexWrap: "wrap",
    "@media (max-width: 600px)": {
      fontSize: "12px",
    },
  },
  packageTitle: {
    height: "24px",
  },
  packageItem: {
    width: "33%",
    height: "150px",
    display: "flex",
    flexDirection: "column",
    // gridRowGap: '20px',
    // margin: 1,
    cursor: "pointer",
    justifyContent: "space-justify",
    textAlign: "center",
    verticalAlign: "top",
    "&:hover": {
      "& p": {
        color: "#F05A28",
      },
      "& path": {
        fill: "#F05A28",
        stroke: "#F05A28",
      },
    },
    "& svg": {
      margin: "auto",
      hegiht: "10vw",
    },
  },
  packageItemActive: {
    "& p": {
      color: "#F05A28",
    },
    "& path": {
      fill: "#F05A28",
      stroke: "#F05A28",
    },
  },
  includes: {
    padding: 17,
    margin: 0,
  },
  includesItem: {
    fontFamily: "Circe",
    fontSize: 16,
    lineHeight: "24px",
    color: "#DADADA",
    "& p": {
      margin: "4px 0",
    },
  },
  slider: {
    color: "#F05A28",
  },
  sliderThumb: {
    width: 20,
    height: 20,
    marginTop: "-8px",
    backgroundColor: "white",
    border: "2px solid #F05A28",
  },
  rail: {
    color: "white",
    height: 3,
  },
  sliderTrack: {
    color: "#F05A28",
    height: 3,
  },
  price: {
    "& > p:first-child": {
      fontFamily: "DINPro",
      fontSize: "24px",
      lineHeight: "32px",
      letterSpacing: "0.2px",
    },
    "& button": {
      // width: 164,
      marginBottom: 16,
    },
  },
  total: {
    fontFamily: "CirceBold",
    fontSize: "48px",
    lineHeight: "64px",
    letterSpacing: "2px",
    margin: "24px 0",
  },
  promo: {
    cursor: "pointer",
    fontFamily: "Circe",
    fontSize: "14px",
    lineHeight: "18px",
    display: "flex",
    alignItems: "left",
    color: "#F05A28",
    flexDirection: "column",
  },
  promoInputForm: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  promoInputContainerShow: {
    display: "none",
  },
  promoInput: {
    width: "70%",
  },
  promoButton: {
    // padding: '9px 64px !important',
    margin: "0 !important",
    width: "30%",
    letterSpacing: "0.5px !important",
    textTransform: "none !important",
    fontFamily: "CirceBold !important",
    fontSize: "18px !important",
    lineHeight: "24px !important",
  },
  insurance: {
    margin: "41px 0",
  },
  insuranceDescription: {
    fontFamily: "Circe",
    fontSize: "16px",
    lineHeight: "24px",
  },
  insuranceItemsUl: {
    padding: "0 22px",
    marginBottom: 0,
    height: 140,
    transition: "height .3s ease-in",
    overflow: "hidden",
    "& li": {
      position: "relative",
      cursor: "pointer",
    },
  },
  insuranceItemsUlOpened: {
    height: "500px !important",
    overflowY: "auto !important",
  },
  insuranceItems: {
    fontFamily: "Circe",
    fontSize: "16px",
    lineHeight: "24px",
    "& p": {
      margin: "10px 0",
      marginTop: 0,
    },
  },
  breadCrumbsItemActive: {
    color: "#F05A28",
  },
});
